<template>
  <v-app class="view">

    <Menu :drawerWidth="drawer_width"></Menu>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>

        <v-row>
          <v-col class="col-md-12">
            รายงาน ออเดอร์ค้างส่งตามช่วงวัน
            <hr/>
          </v-col>
        </v-row>

        <v-row>
          <v-col style="max-width: 140px">
            <v-select
                class=""
                v-model="logistic_report_date_type"
                label="ตาม"
                :items="[{text:'วันส่ง',value:'date_delivery'},{text:'วันสั่ง',value:'erp_so_at'}]"
                hide-details
                outlined
                required
                width="100"
                @change="reload_option_pending()"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 320px">
            <v-btn
                height="54px"
                class="title"
                ourlined tile @click="isPickingDate=!isPickingDate">
              {{ logistic_report_date_from }} - {{ logistic_report_date_to }}
            </v-btn>
          </v-col>
          <v-col style="max-width: 200px">
            <v-select
                class=""
                v-model="logistic_report_status"
                label="สถานะ"
                :items="[{text:'ทั้งหมด',value:'all'},{text:'ยังไม่มีรถ',value:'null'},'ดราฟ','จอง','รออนุมัติ','อนุมัติ']"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 200px">
            <v-select
                class=""
                v-model="logistic_report_docbook"
                label="เล่ม"
                :items="['SOPJ','SOHM','SOTT','SOMT','SOSO']"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 320px">
            <v-select
                class=""
                v-model="logistic_report_province"
                label="จังหวัด"
                :items="logistic_report_selectable_provinces"
                :loading="logistic_report_selectable_provinces_loading"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col cols="1">
            <a :href="'/api/reports/logistic_pending_order?'+
            'date_type='+logistic_report_date_type+
            '&from_date='+logistic_report_date_from+
            '&to_date='+logistic_report_date_to+
            '&status='+logistic_report_status.join(',')+
            '&docbook='+logistic_report_docbook.join(',')+
            '&provinces='+logistic_report_province.join(',')+
            '&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn class="title" height="54px"
              >เปิด
              </v-btn>
            </a>

            <div style="clear: both;margin: 0;padding: 0"></div>

          </v-col>
        </v-row>
        <v-dialog v-model="isPickingDate"
                  width="700"
        >
          <v-card>
            <v-card-title>เลือกวันที่ ตั้งแต่ ... ถึง ...
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-date-picker
                      v-model="logistic_report_date_from"
                      locale="th"
                  ></v-date-picker>
                </v-col>
                <v-col>
                  <v-date-picker
                      v-model="logistic_report_date_to"
                      locale="th"
                  ></v-date-picker>

                </v-col>
              </v-row>


            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="close-button" color="primary" fab tile
                     @click="isPickingDate=false;reload_option_pending()">
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col class="col-md-6">
            รายงาน ออเดอร์ค้างส่งรายเดือน
            <hr/>

            <br/>
            <a :href="'/api/reports/logistic_pending_order?from_date='+logistic_report_month[0]+'&to_date='+logistic_report_month[1]+'&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn class="ma-2"
              >เปิด
              </v-btn>
            </a>
            <a :href="'/api/reports/logistic_pending_order?from_date='+logistic_report_month[0]+'&to_date='+logistic_report_month[1]+'&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn>สรุป</v-btn>
            </a>
            <v-select
                v-model="logistic_report_month"
                :items="months"
                class="select-no-message"
                label="เดือน"
                outlined
                style="float: left;width: 120px"
            ></v-select>
            <div style="clear: both;margin: 0;padding: 0"></div>
            <a :href="'/api/reports/logistic_pending_order?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
               target="_blank">
              ค้างส่งเดือนนี้</a> |
            <a :href="'/api/reports/logistic_pending_order?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
               target="_blank">l
              สรุป
            </a>

            <br/>
            <a :href="'/api/reports/logistic_pending_order?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
               target="_blank">
              ค้างส่งเดือนที่แล้ว</a> |
            <a :href="'/api/reports/logistic_pending_order?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
               target="_blank">
              สรุป
            </a>
            <br/>
            <a :href="'/api/reports/logistic_pending_order?token='+$helper.access_token()"
               target="_blank">
              ค้างส่งทั้งหมด</a> |
            <a :href="'/api/reports/logistic_pending_order?token='+$helper.access_token()"
               target="_blank">
              สรุป
            </a>
            <br/>
          </v-col>
          <v-col class="col-md-6">
            รายงาน ออเดอร์จัดทริป
            <hr/>

            <br/>
            <a :href="'/api/reports/logistic_by_order?from_date='+logistic_report_month[0]+'&to_date='+logistic_report_month[1]+'&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn class="ma-2"
              >เปิด
              </v-btn>
            </a>
            <a :href="'/api/reports/logistic_by_order?from_date='+logistic_report_month[0]+'&to_date='+logistic_report_month[1]+'&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn>สรุป</v-btn>
            </a>
            <v-select
                v-model="logistic_report_month"
                :items="months"
                class="select-no-message"
                label="เดือน"
                outlined
                style="float: left;width: 120px"
            ></v-select>
            <div style="clear: both;margin: 0;padding: 0"></div>
            <a :href="'/api/reports/logistic_by_order?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
               target="_blank">
              ส่งเดือนนี้</a> |
            <a :href="'/api/reports/logistic_by_order?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
               target="_blank">l
              สรุป
            </a>

            <br/>
            <a :href="'/api/reports/logistic_by_order?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
               target="_blank">
              ส่งเดือนที่แล้ว</a> |
            <a :href="'/api/reports/logistic_by_order?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
               target="_blank">
              สรุป
            </a>
            <br/>
            <a :href="'/api/reports/logistic_by_order?token='+$helper.access_token()"
               target="_blank">
              ส่งทั้งหมด</a> |
            <a :href="'/api/reports/logistic_by_order?token='+$helper.access_token()"
               target="_blank">
              สรุป
            </a>
            <br/>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-md-12">
            รายงาน ออเดอร์ส่งรายวัน
            <hr/>
          </v-col>
        </v-row>

        <v-row>
          <v-col style="max-width: 140px">
            <v-select
                class=""
                v-model="logistic_report_daily_type"
                label="ตาม"
                :items="[{text:'วันกำหนดส่ง',value:'date_delivery'},{text:'วันส่งจริง',value:'do_delivered_at'}]"
                hide-details
                outlined
                required
                width="100"
                @change="reload_option_daily()"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 320px">
            <v-btn
                height="54px"
                class="title"
                ourlined tile @click="isPickingDaily=!isPickingDaily">
              {{ logistic_report_daily_from }} - {{ logistic_report_daily_to }}
            </v-btn>
          </v-col>
          <v-col style="max-width: 200px">
            <v-select
                class=""
                v-model="logistic_report_daily_status"
                label="สถานะ"
                :items="[{text:'ทั้งหมด',value:'all'},{text:'ไม่มีข้อมูล',value:'none'},{text:'ส่งสำเร็จ',value:'success'},{text:'ส่งไม่สำเร็จ',value:'failed'}]"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 200px">
            <v-select
                class=""
                v-model="logistic_report_daily_docbook"
                label="เล่ม"
                :items="['SOPJ','SOHM','SOTT','SOMT','SOSO']"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col style="max-width: 320px">
            <v-select
                class=""
                v-model="logistic_report_daily_province"
                label="จังหวัด"
                :items="logistic_report_daily_selectable_provinces"
                :loading="logistic_report_daily_selectable_provinces_loading"
                multiple
                hide-details
                outlined
                required
                width="200"
            >
            </v-select>
          </v-col>
          <v-col cols="1">
            <a :href="'/api/reports/logistic_daily_shipping?'+
            'date_type='+logistic_report_daily_type+
            '&from_date='+logistic_report_daily_from+
            '&to_date='+logistic_report_daily_to+
            '&status='+logistic_report_daily_status.join(',')+
            '&docbook='+logistic_report_daily_docbook.join(',')+
            '&provinces='+logistic_report_daily_province.join(',')+
            '&token='+$helper.access_token()"
               style="text-decoration: none" target="_blank">
              <v-btn class="title" height="54px"
              >เปิด
              </v-btn>
            </a>

            <div style="clear: both;margin: 0;padding: 0"></div>

          </v-col>
        </v-row>
        <v-dialog v-model="isPickingDaily"
                  width="700"
        >
          <v-card>
            <v-card-title>เลือกวันที่ ตั้งแต่ ... ถึง ...
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-date-picker
                      v-model="logistic_report_daily_from"
                      locale="th"
                  ></v-date-picker>
                </v-col>
                <v-col>
                  <v-date-picker
                      v-model="logistic_report_daily_to"
                      locale="th"
                  ></v-date-picker>

                </v-col>
              </v-row>


            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="close-button" color="primary" fab tile
                     @click="isPickingDaily=false;reload_option_daily()">
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!--<v-btn-->
        <!--@click="$root.$emit('openOrderPicker', {onApply: () => {}})">-->
        <!--  openOrderPicker-->
        <!--</v-btn>-->
      </v-container>
    </v-content>

  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}


</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {Order} from '@/models/Order'
import {DataArray} from '@/models/Response'
import {UserConst} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  computed: {
    Order() {
      return Order
    }
  },
  components: {LoadingDummy, Menu}
})
export default class ViewLogisticReport extends Vue {

  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  UserConst = UserConst
  monthCurrentDateFrom = ''
  monthCurrentDateTo = ''
  monthPreviousDateFrom = ''
  monthPreviousDateTo = ''
  months = [{text: 'สค. 63', value: ['', '']}]
  months_with_current = [{text: 'สค. 63', value: ['', '']}]

  logistic_report_month_from = ['2020-06-01', '2020-06-30']
  logistic_report_month_to = ['2020-06-01', '2020-06-30']
  logistic_report_month = ['2020-06-01', '2020-06-30']

  isPickingDate = false
  logistic_report_date_type = 'erp_so_at'
  logistic_report_date_from = '2020-06-01'
  logistic_report_date_to = '2020-06-01'
  logistic_report_status = ['all']
  logistic_report_province = []
  logistic_report_docbook = ['SOPJ', 'SOHM', 'SOTT']
  logistic_report_selectable_provinces_loading = true
  logistic_report_selectable_provinces = []


  isPickingDaily = false
  logistic_report_daily_type = 'do_delivered_at'
  logistic_report_daily_from = '2020-06-01'
  logistic_report_daily_to = '2020-06-01'
  logistic_report_daily_status = ['all']
  logistic_report_daily_province = []
  logistic_report_daily_docbook = ['SOPJ', 'SOHM', 'SOTT']
  logistic_report_daily_selectable_provinces_loading = false
  logistic_report_daily_selectable_provinces = []

  async reload_option_pending() {
    this.logistic_report_selectable_provinces_loading = true
    const url = Helper.setting.logistic.getReportOptionAPI +
        '?date_type=' + this.logistic_report_date_type +
        '&from_date=' + this.logistic_report_date_from +
        '&to_date=' + this.logistic_report_date_to
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      console.log('reload_option_pending', data)
      this.logistic_report_selectable_provinces = data.provinces
      this.logistic_report_selectable_provinces_loading = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }
  async reload_option_daily() {
    this.logistic_report_daily_selectable_provinces_loading = true
    const url = Helper.setting.logistic.getReportOptionAPI +
        '?date_type=' + this.logistic_report_daily_type +
        '&from_date=' + this.logistic_report_daily_from +
        '&to_date=' + this.logistic_report_daily_to
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      console.log('reload_option_daily', data)
      this.logistic_report_daily_selectable_provinces = data.provinces
      this.logistic_report_daily_selectable_provinces_loading = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  async mounted() {

    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.monthPreviousDateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.monthPreviousDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.monthCurrentDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.monthCurrentDateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)

    this.logistic_report_month = [
      this.monthPreviousDateFrom, this.monthPreviousDateTo
    ]

    this.logistic_report_month_from = [
      this.monthPreviousDateFrom, this.monthPreviousDateTo
    ]

    this.logistic_report_month_to = [
      this.monthCurrentDateFrom, this.monthCurrentDateTo
    ]

    this.logistic_report_date_from = this.monthCurrentDateFrom
    this.logistic_report_date_to = this.monthCurrentDateTo
    this.reload_option_pending().then(r => {
    })

    this.logistic_report_daily_from = this.monthCurrentDateTo
    this.logistic_report_daily_to = this.monthCurrentDateTo
    this.reload_option_daily().then(r => {
    })

    var firstOfMonth = tmpDateFrom
    var dateSpin = new Date('2020-06-01')

    this.months = []
    this.months_with_current = []
    while (dateSpin <= firstOfMonth) {
      dateSpin.setMonth(dateSpin.getMonth() + 1)

      var tmpDateFrom = new Date(dateSpin)
      tmpDateFrom.setDate(0)
      const tmpMonthPreviousDateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
      tmpDateFrom.setDate(1)
      const tmpMonthPreviousDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

      this.months.push({
        text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
            [
              tmpMonthPreviousDateFrom,
              tmpMonthPreviousDateTo
            ]
      })

      this.logistic_report_month = [
        tmpMonthPreviousDateFrom, tmpMonthPreviousDateTo
      ]

      this.months_with_current.push({
        text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
            [
              tmpMonthPreviousDateFrom,
              tmpMonthPreviousDateTo
            ]
      })
    }

    dateSpin.setMonth(dateSpin.getMonth() + 1)

    var tmpDateFrom2 = new Date(dateSpin)
    tmpDateFrom2.setDate(0)
    tmpDateFrom2.setDate(1)
    const tmpMonthPreviousDateFrom = (new Date(tmpDateFrom2.getTime() - tzoffset)).toISOString().substr(0, 10)

    this.months_with_current.push({
      text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
          [
            this.monthCurrentDateFrom,
            this.monthCurrentDateTo
          ]
    })

    //


  }


}
</script>
